import { APPROVAL_FILTER, type ApprovalFilter } from '@access-cms/shared-constants';

export interface ApprovalFilterOption<TValue extends string = string> {
  label: string;
  value: TValue;
}

export const APPROVAL_FILTER_OPTIONS = [
  { label: 'Pending', value: APPROVAL_FILTER.PENDING },
  { label: 'COR Review', value: APPROVAL_FILTER.COR_REVIEW },
  { label: 'DSI Review', value: APPROVAL_FILTER.DSI_REVIEW },
] satisfies ApprovalFilterOption<ApprovalFilter>[];
